// Generated by scripts/build-ui-icons.mjs.
export { StarSelected as default } from "../ui/selected";
